import { render, staticRenderFns } from "./OrderShowModal.vue?vue&type=template&id=2d776533&scoped=true&"
import script from "./OrderShowModal.vue?vue&type=script&lang=js&"
export * from "./OrderShowModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderShowModal.vue?vue&type=style&index=0&id=2d776533&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d776533",
  null
  
)

export default component.exports